/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {MainLayout} from '~/layouts/main';
export const meta = {
  title: 'DIP | Антипаттерны и запахи',
  description: 'Антипаттерны и запахи кода, которые мешают следовать принципу инверсии зависимостей'
};
const MDXLayout = ({children}) => _jsx(MainLayout, {
  meta: meta,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      section: "section",
      h1: "h1",
      p: "p",
      h2: "h2",
      a: "a",
      code: "code",
      pre: "pre",
      em: "em",
      ul: "ul",
      li: "li"
    }, _provideComponents(), props.components);
    return _jsxs(_components.section, {
      children: [_jsx(_components.h1, {
        children: "Антипаттерны и запахи"
      }), _jsx(_components.p, {
        children: "Основная проблема антипаттернов и запахов ниже — в сокрытии зависимостей и увеличении зацепления модулей друг с другом."
      }), _jsxs(_components.section, {
        children: [_jsx(_components.h2, {
          children: "Контрол-фрик"
        }), _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://habr.com/ru/post/166287/",
            children: "Контрол-фрик"
          }), " — это запах, при котором зависимости явно создаются в конструкторе с помощью ", _jsx(_components.code, {
            children: "new"
          }), "."]
        }), _jsx(_components.pre, {
          children: _jsx(_components.code, {
            className: "language-ts",
            children: "class Auth {\n  // обратите внимание на отсутствие аргументов у конструктора\n  // и ключевое слово new внутри\n  constructor() {\n    this.connection = new MySqlConnection()\n  }\n}\n"
          })
        }), _jsxs(_components.p, {
          children: ["Класс ", _jsx(_components.code, {
            children: "Auth"
          }), " становится жёстко зацепленным с ", _jsx(_components.code, {
            children: "MySqlConnection"
          }), ", то есть ", _jsx(_components.em, {
            children: "не может работать без него"
          }), ". Это нарушает ", _jsx(_components.a, {
            href: "/ocp",
            children: "OCP"
          }), ", ", _jsx(_components.a, {
            href: "/lsp",
            children: "LSP"
          }), " и ", _jsx(_components.a, {
            href: "/isp",
            children: "ISP"
          }), "."]
        }), _jsxs(_components.p, {
          children: ["Также чтобы протестировать такой класс, придётся сделать ", _jsx(_components.em, {
            children: "глобальный"
          }), " мок для ", _jsx(_components.code, {
            children: "MySqlConnection"
          }), ". Это ресурсозатратно и засоряет глобальную область видимости."]
        })]
      }), _jsxs(_components.section, {
        children: [_jsx(_components.h2, {
          children: "Локатор служб"
        }), _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://ru.wikipedia.org/wiki/%D0%9B%D0%BE%D0%BA%D0%B0%D1%82%D0%BE%D1%80_%D1%81%D0%BB%D1%83%D0%B6%D0%B1",
            children: "Локатор служб"
          }), " — шаблон, который позволяет подключать зависимости в момент, когда они становятся нужны."]
        }), _jsxs(_components.p, {
          children: ["Мы называем его антипаттерном с оговоркой, что ", _jsx(_components.a, {
            href: "https://stackoverflow.com/questions/22795459/is-servicelocator-an-anti-pattern",
            children: "есть ситуации, когда он нужен"
          }), " — например, при работе с легаси. Но при создании новой системы лучше использовать DI."]
        }), _jsxs(_components.p, {
          children: ["Самый главный минус этого шаблона в том, что он нарушает ", _jsx(_components.a, {
            href: "https://ru.wikipedia.org/wiki/%D0%98%D0%BD%D0%BA%D0%B0%D0%BF%D1%81%D1%83%D0%BB%D1%8F%D1%86%D0%B8%D1%8F_(%D0%BF%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B5)",
            children: "инкапсуляцию"
          }), ", ", _jsx(_components.a, {
            href: "https://stackoverflow.com/questions/22795459/is-servicelocator-an-anti-pattern",
            children: "скрывая зависимости"
          }), "."]
        }), _jsx(_components.p, {
          children: "Понять код и предугадать его поведение становится трудно — ведь, чтобы узнать все зависимости необходимо изучить исходники. IDE уже не сможет подсказать, какие зависимости необходимы для создания класса."
        }), _jsx(_components.p, {
          children: "При использовании DI такой проблемы нет — у нас просто не получится создать экземпляр класса,не передав все необходимые зависимости."
        })]
      }), _jsxs(_components.section, {
        children: [_jsx(_components.h2, {
          children: "Материалы к разделу"
        }), _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "https://habr.com/ru/post/166287/",
              children: "Dependency Injection: антипаттерны"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "https://ru.wikipedia.org/wiki/%D0%9B%D0%BE%D0%BA%D0%B0%D1%82%D0%BE%D1%80_%D1%81%D0%BB%D1%83%D0%B6%D0%B1",
              children: "Локатор служб"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "https://stackoverflow.com/questions/22795459/is-servicelocator-an-anti-pattern",
              children: "Is Service Locator an Antipattern?"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(_components.a, {
              href: "https://blog.ploeh.dk/2010/02/03/ServiceLocatorisanAnti-Pattern/",
              children: "Service Locator is an Antipattern, Mark Seemann"
            })
          }), "\n"]
        })]
      })]
    });
  }
}
export default MDXContent;
